function t(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(n) {
    a[++e] = n;
  }), a;
}
export {
  t as default
};
